export const SUPPORTED_LANGS = [
  { value: 'en', name: 'English', shortLabel: 'EN' },
  { value: 'hu', name: 'Magyar', shortLabel: 'HU' },
  { value: 'nl-NL', name: 'Nederlands', shortLabel: 'NL' },
  { value: 'pl', name: 'Polski', shortLabel: 'PL' },
  { value: 'ro', name: 'Română', shortLabel: 'RO' },
  { value: 'de', name: 'Deutsch', shortLabel: 'DE' },
  { value: 'uk', name: 'Українська', shortLabel: 'UA' },
  { value: 'bg', name: 'Български', shortLabel: 'BG' },
  { value: 'it', name: 'Italiano', shortLabel: 'IT' },
  { value: 'fr', name: 'Français', shortLabel: 'FR' },
  { value: 'es-ES', name: 'Español', shortLabel: 'ES' },
  { value: 'sr', name: 'Српски', shortLabel: 'SR' },
  { value: 'en-GB', name: 'English (UK)', shortLabel: 'En-GB' },
];

export const NONDDG_SUPPORTED_LANGS = [
  { value: 'en', name: 'English', shortLabel: 'EN' },
  { value: 'hu', name: 'Magyar', shortLabel: 'HU' },
  { value: 'nl-NL', name: 'Nederlands', shortLabel: 'NL' },
  { value: 'pl', name: 'Polski', shortLabel: 'PL' },
  { value: 'ro', name: 'Română', shortLabel: 'RO' },
  { value: 'de', name: 'Deutsch', shortLabel: 'DE' },
  { value: 'uk', name: 'Українська', shortLabel: 'UA' },
  { value: 'bg', name: 'Български', shortLabel: 'BG' },
  { value: 'it', name: 'Italiano', shortLabel: 'IT' },
  { value: 'cs', name: 'Čeština', shortLabel: 'CS' },
  { value: 'fr', name: 'Français', shortLabel: 'FR' },
  { value: 'pt', name: 'Português', shortLabel: 'PT' },
  { value: 'ru', name: 'Русский', shortLabel: 'RU' },
  { value: 'sr', name: 'Српски', shortLabel: 'SR' },
  { value: 'sk', name: 'Slovenský', shortLabel: 'SK' },
  { value: 'es-ES', name: 'Español', shortLabel: 'ES' },
  { value: 'tr-TR', name: 'Türkçe', shortLabel: 'Tr-TR' },
  { value: 'en-GB', name: 'English (UK)', shortLabel: 'En-GB' },
];
